class ProductFlexiblePlan extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
		this.element = this;
		this.masterSelector = this.element.querySelector('#product-flexible-plan-js');
    this.selector = {
			plan: '.product-plan',
			planOption: '.product-plan-option',
			planName: '.product-plan-name',
			sellingPlan: '#selling-plan',
			add: '.btn-plan-add'
    }

    this.init();
  }

  init() {
    console.log('Product Flexible Plan loaded');

    this.initEventListener();
		this.initAddToCart();
		this.initPackChange();
		this.initNappySize();
		this.syncPlanToPack();
		this.updateOneTimePrice();

		document.addEventListener('on:variant:change', (event) => {
			this.initNappySize();
			this.initPackChange();
			this.syncPlanToPack();
			this.updateOneTimePrice();
		});

		this.element.querySelector(this.selector.sellingPlan)?.addEventListener('change', () => {
			this.updateBoxInfo();
		});

		this.initChevron();
  }

	initChevron() {
		const select = this.element.querySelector(this.selector.sellingPlan);
		const container = select?.closest('.recharge-frequency');

		if (!select || !container) return;

		// Native selects don't emit open/close events, so approximate the open
		// state: clicking toggles it, and blur/change/outside-click resets it.
		select.addEventListener('mousedown', () => {
			container.classList.toggle('is-open');
		});

		select.addEventListener('keydown', (event) => {
			if (['Enter', ' ', 'ArrowDown', 'ArrowUp'].includes(event.key)) {
				container.classList.add('is-open');
			}
		});

		select.addEventListener('blur', () => {
			container.classList.remove('is-open');
		});

		select.addEventListener('change', () => {
			container.classList.remove('is-open');
		});

		// blur doesn't reliably fire when dismissing an open native select by
		// clicking elsewhere on the page, so reset on any outside pointer down.
		document.addEventListener('mousedown', (event) => {
			if (!container.contains(event.target)) {
				container.classList.remove('is-open');
			}
		});
	}

  initEventListener() {
		// Plan switch event
		this.element.querySelectorAll(this.selector.plan).forEach((plan) => {
			plan.addEventListener('click', () => {
				this.element.querySelector(`${this.selector.plan}.active`)?.classList.remove('active');
				plan.classList.toggle('active');
			})
		})

		// Plan option switch event
		this.element.querySelectorAll(this.selector.planOption).forEach((option) => {
			option.addEventListener('click', () => {
				this.element.querySelector(`${this.selector.planOption}.active`)?.classList.remove('active');
				option.classList.toggle('active');

				// Update price
				const planRow = option.closest('.product-plan');
				const elComparePrice = planRow.querySelector('.product-plan-price .compare-price');
				const elRegularPrice = planRow.querySelector('.product-plan-price .regular-price');
				const optComparePrice = option.querySelector('.compare-price');
				const optRegularPrice = option.querySelector('.regular-price');
				if(elRegularPrice && optRegularPrice) {
					elRegularPrice.innerText = optRegularPrice.innerText;
				}
				// Mirror the active option's compare price, hiding it when that option has
				// none — otherwise the previous option's compare price stays on screen,
				// struck through beside the new option's price.
				if(elComparePrice) {
					if(optComparePrice && optComparePrice.innerText.trim()) {
						elComparePrice.innerText = optComparePrice.innerText;
						elComparePrice.classList.remove('hidden');
					} else {
						elComparePrice.innerText = '';
						elComparePrice.classList.add('hidden');
					}
				}

				// Update plan header nappy count and box info for the selected option (honours data-box-count, e.g. Deluxe = 7 boxes)
				this.updatePlanName(option.closest('.product-plan'));
				this.updateBoxInfo();
			})
		})
  }

	initNappySize() {
		this.element.querySelectorAll(this.selector.plan).forEach((plan) => {
			this.updatePlanName(plan);
		})
		this.updateBoxInfo();
	}

	updatePlanName(plan) {
		const elName = plan.querySelector(this.selector.planName);
		if(!elName) return;
		const defaultPack = plan.dataset.defaultPack;
		const sizeEl = document.querySelector('.js-variant-option[data-type="size"]:checked');
		if(!sizeEl) return;
		// The Single Pack plan is pinned to '1 pack'; the flexible and one-time plans
		// follow the pack selected in the variant picker (e.g. 3 packs → 48 nappies).
		let pack = defaultPack;
		if (defaultPack !== '1 pack') {
			const packEl = document.querySelector('.js-variant-option[data-type="pack"]:checked');
			if (packEl) pack = packEl.value;
		}
		const target = this.masterSelector.querySelector(`option[data-pack="${pack}"][data-size="${sizeEl.value}"]`);
		if(!target) return;
		const nappySizePerPack = parseFloat(target.dataset.nappySizePerPack);
		const packCount = parseFloat(pack.replace(' packs', '').replace(' pack', ''));
		const activeOption = plan.querySelector(`${this.selector.planOption}.active`);
		const boxCount = activeOption ? parseFloat(activeOption.dataset.boxCount) : NaN;
		const multiplier = isNaN(boxCount) ? packCount : boxCount;
		let count = multiplier * nappySizePerPack;
		if(isNaN(count)) return;
		const defaultTitle = elName.dataset.prefix;
		elName.innerText = `${defaultTitle} (${count} nappies)`;
	}

	getSelectedMasterOption() {
		const sizeEl = document.querySelector('.js-variant-option[data-type="size"]:checked');
		const packEl = document.querySelector('.js-variant-option[data-type="pack"]:checked');
		if (!sizeEl || !packEl) return null;
		return this.masterSelector.querySelector(`option[data-pack="${packEl.value}"][data-size="${sizeEl.value}"]`);
	}

	// The subscription (flexible) plan only applies to packs that carry selling plans
	// (the 8-pack box). Packs without plans (e.g. 3 packs) are one-time only: hide the
	// flexible plan — including its bundle options — and activate the one-time plan.
	syncPlanToPack() {
		const flexBtn = this.element.querySelector('.btn-plan-add[data-type="subscription"]');
		const flexPlan = flexBtn ? flexBtn.closest('.product-plan') : null;
		if (!flexPlan) return;
		const masterOption = this.getSelectedMasterOption();
		if (!masterOption) return;
		const hasPlans = parseInt(masterOption.dataset.hasPlans, 10) > 0;
		flexPlan.classList.toggle('hidden', !hasPlans);
		const onetimeBtn = this.element.querySelector('.btn-plan-add[data-type="onetime"]');
		const onetimePlan = onetimeBtn ? onetimeBtn.closest('.product-plan') : null;
		const target = hasPlans ? flexPlan : onetimePlan;
		if (!target || target.classList.contains('active')) return;
		this.element.querySelector(`${this.selector.plan}.active`)?.classList.remove('active');
		target.classList.add('active');
	}

	updateOneTimePrice() {
		const onetimeBtn = this.element.querySelector('.btn-plan-add[data-type="onetime"]');
		const plan = onetimeBtn ? onetimeBtn.closest('.product-plan') : null;
		if (!plan) return;
		const masterOption = this.getSelectedMasterOption();
		if (!masterOption || !masterOption.dataset.price) return;
		const priceEl = plan.querySelector('.product-plan-price .regular-price');
		if (priceEl) priceEl.innerText = this.formatMoney(masterOption.dataset.price);
	}

	updateBoxInfo() {
		const infoEl = this.element.querySelector('.product-plan-info');
		if(!infoEl) return;
		const sizeEl = document.querySelector('.js-variant-option[data-type="size"]:checked');
		if(!sizeEl) return;
		const target = this.masterSelector.querySelector(`option[data-pack="8 packs"][data-size="${sizeEl.value}"]`);
		if(!target) return;
		const nappySizePerPack = parseFloat(target.dataset.nappySizePerPack);
		if(isNaN(nappySizePerPack)) return;
		const activeOption = this.element.querySelector(`${this.selector.planOption}.active`);
		const boxCount = activeOption ? parseFloat(activeOption.dataset.boxCount) : NaN;
		const boxes = isNaN(boxCount) ? 8 : boxCount;
		const sellingPlan = this.element.querySelector(this.selector.sellingPlan);
		let deliveryDays = 30;
		if(sellingPlan && sellingPlan.selectedIndex >= 0) {
			const frequency = parseFloat(sellingPlan.options[sellingPlan.selectedIndex].dataset.frequency);
			if(!isNaN(frequency) && frequency > 0) {
				deliveryDays = frequency;
			}
		}
		const nappiesPerBox = boxes * nappySizePerPack;
		const changesPerDay = Math.round(nappiesPerBox / deliveryDays);
		infoEl.innerHTML = `${nappiesPerBox} nappies per box • ${changesPerDay} changes/day`;
	}

	initPackChange() {
		const packNightPromo = document.querySelector('.pack-night-promo');
		if(!packNightPromo) {
			return;
		}
		const selectedPack = document.querySelector(`.js-variant-option[data-type="pack"]:checked`);
		if(selectedPack && selectedPack.value == '3 packs') {
			packNightPromo.classList.remove('hidden');
		}
		else {
			packNightPromo.classList.add('hidden');
		}
	}

	initAddToCart() {
		this.element.querySelectorAll(this.selector.add).forEach((btn) => {
			btn.addEventListener('click', async () => {
				if (btn.getAttribute('aria-disabled') === 'true') return;

				const type = btn.dataset.type;
				const sellingPlan = this.element.querySelector(`${this.selector.sellingPlan}`);
				let selected_pack = document.querySelector('.js-variant-option[data-type="pack"]:checked').value;
				let selected_size = document.querySelector('.js-variant-option[data-type="size"]:checked').value;
				let masterOption = this.masterSelector.querySelector(`option[data-pack="${selected_pack}"][data-size="${selected_size}"]`);
				let data = null;
				if(type == 'subscription') {
					const plan = this.element.querySelector(`${this.selector.planOption}.active`).dataset.type;
					selected_pack = '8 packs';
					masterOption = this.masterSelector.querySelector(`option[data-pack="${selected_pack}"][data-size="${selected_size}"]`);
					if (plan == 'default') {
						data = {
							id: masterOption.value,
							quantity: 1,
							selling_plan: sellingPlan.value
						}
					}
					else {
						let bundleData = null;
						if(plan == 'bundle-wipes') {
							bundleData = masterOption.dataset.bundleWipes;
						}
						else {
							bundleData = masterOption.dataset.bundleDeluxe;
						}
						const bundleDataJson = JSON.parse(bundleData);
						const frequency = sellingPlan.options[sellingPlan.selectedIndex].dataset.frequency;
						data = {
							id: bundleDataJson.id,
							quantity: 1
						}
						const rechargePlan = bundleDataJson?.recharge_plans;
						if(rechargePlan[frequency]) {
							data.selling_plan = rechargePlan[frequency];
						}
					}
				}
				else if (type == 'onetime') {
					data = {
						id: masterOption.value,
						quantity: 1
					}
				}
				else if (type == 'single') {
					selected_pack = '1 pack';
					masterOption = this.masterSelector.querySelector(`option[data-pack="${selected_pack}"][data-size="${selected_size}"]`);
					data = {
						id: masterOption.value,
						quantity: 1
					}
				}

				btn.setAttribute('aria-disabled', 'true');
				btn.classList.add('is-loading');

				try {
					await this.addToCartAndUpdateUI(data);
					btn.classList.add('is-success');
				} catch (err) {
					console.log(err); // eslint-disable-line
					this.dispatchEvent(new CustomEvent('on:cart:error', {
						bubbles: true,
						detail: { error: err.message }
					}));
				} finally {
					btn.removeAttribute('aria-disabled');
					setTimeout(() => {
						btn.classList.remove('is-loading');
						btn.classList.remove('is-success');
					}, 1400);
				}
			})
		})
	}

	getCartDrawerInfo() {
		const cartDrawer = document.querySelector('cart-drawer');
		if (!cartDrawer) return null;
		const section = cartDrawer.closest('.shopify-section');
		if (!section) return null;
		return {
			cartDrawer,
			sectionId: section.id.replace('shopify-section-', '')
		};
	}

	getSectionsParam() {
		const info = this.getCartDrawerInfo();
		if (!info) return 'cart-icon-bubble';
		return `cart-icon-bubble,${info.sectionId}`;
	}

	updateCartIcon(response) {
		const cartIconBubble = document.getElementById('cart-icon-bubble');
		if (cartIconBubble && response.sections?.['cart-icon-bubble']) {
			cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
		}
	}

	async addToCartAndUpdateUI(lineItem) {
		if (!lineItem?.id) return;

		const cartInfo = this.getCartDrawerInfo();
		const response = await fetch(theme.routes.cartAdd, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json'
			},
			body: JSON.stringify({
				items: [lineItem],
				sections: this.getSectionsParam(),
				sections_url: window.location.pathname
			})
		});

		const addData = await response.json();
		const error = typeof addData.description === 'string' ? addData.description : addData.message;
		if (!response.ok) {
			throw new Error(error || response.status);
		}

		this.updateCartIcon(addData);

		const openDrawer = theme.settings.afterAtc === 'drawer';

		if (theme.settings.afterAtc === 'page') {
			setTimeout(() => {
				window.location.href = theme.routes.cart;
			}, 300);
			return addData;
		}

		if (cartInfo?.cartDrawer?.renderContents) {
			await cartInfo.cartDrawer.renderContents(addData, openDrawer);
		} else if (openDrawer) {
			document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));
		}

		const cartResponse = await fetch(`${theme.routes.cart}.js`);
		if (cartResponse.ok) {
			const cart = await cartResponse.json();
			this.dispatchEvent(new CustomEvent('on:cart:add', {
				bubbles: true,
				detail: {
					cart,
					variantId: addData.variant_id || Number(lineItem.id)
				}
			}));
		}

		return addData;
	}

	// ---------------------------------------------------------------------------
	// Money format handler
	// ---------------------------------------------------------------------------
	formatMoney(cents, format) {
		const money_format = "${{amount}}";
		if (typeof cents == 'string') { cents = cents.replace('.',''); }
		var value = '';
		var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		var formatString = (format || money_format);

		function defaultOption(opt, def) {
			return (typeof opt == 'undefined' ? def : opt);
		}

		function formatWithDelimiters(number, precision, thousands, decimal) {
			precision = defaultOption(precision, 2);
			thousands = defaultOption(thousands, ',');
			decimal   = defaultOption(decimal, '.');

			if (isNaN(number) || number == null) { return 0; }

			number = (number/100.0).toFixed(precision);

			var parts   = number.split('.'),
					dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
					cents   = parts[1] ? (decimal + parts[1]) : '';

			return dollars + cents;
		}

		switch(formatString.match(placeholderRegex)[1]) {
			case 'amount':
				value = formatWithDelimiters(cents, 2);
				break;
			case 'amount_no_decimals':
				value = formatWithDelimiters(cents, 0);
				break;
			case 'amount_with_comma_separator':
				value = formatWithDelimiters(cents, 2, '.', ',');
				break;
			case 'amount_no_decimals_with_comma_separator':
				value = formatWithDelimiters(cents, 0, '.', ',');
				break;
		}

		return formatString.replace(placeholderRegex, value);
	};
}

customElements.define('product-flexible-plan', ProductFlexiblePlan);